import { render, staticRenderFns } from "./CoachDetailMessage.vue?vue&type=template&id=1cc01cde&scoped=true&lang=pug"
import script from "./CoachDetailMessage.vue?vue&type=script&lang=js"
export * from "./CoachDetailMessage.vue?vue&type=script&lang=js"
import style0 from "./CoachDetailMessage.vue?vue&type=style&index=0&id=1cc01cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc01cde",
  null
  
)

export default component.exports